import refer_friend_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/refer-friend-widget/ui/src/refer-friend-widget.js";



import refer_friend_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/refer-friend-widget/ui/src/refer-friend-widget.scss";refer_friend_widget_0();